import { AppLogo } from "@/shared/ui/AppLogo";

export function SidebarBrand() {
  return (
    <div className="flex items-center gap-3 px-2 py-2">
      <AppLogo size="sm" backing="light" />
      <div className="grid min-w-0 flex-1 text-start text-sm leading-tight">
        <span className="truncate font-heading font-semibold text-sidebar-foreground tracking-widest">
          Mineral Coffee
        </span>
        <span className="truncate text-sidebar-foreground/65 text-xs">
          Back office · Admin
        </span>
      </div>
    </div>
  );
}
